import React, { useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faList } from '@fortawesome/free-solid-svg-icons';
import validator from 'validator'
import { teamService } from '../../../Services';
import { teamActions } from '../../../Actions';

const Edit = () => {
  const location = useLocation();
  const { team_id } = location.state;
  const team = useSelector((state) => state.team);
  const dispatch = useDispatch();

  const [submitted, setSubmitted] = useState(false);

  let team_member, team_key;
  team.map((val, key) => {
    if(team_id == val.id) {
      team_member = val;
      team_key = key;
    }
  })
  const [input, setInput] = useState({
    email: team_member.email? team_member.email: "",
    phone: team_member.phone? team_member.phone: "",
    gender: team_member.gender? team_member.gender: "",
  });

  const [validationError, setValidationError] = useState({});
  const ref = useRef([]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInput(input => ({ ...input, [name]: value }));
  }

  const checkValidation = () => {
    let error = {};
    Object.keys(input).map(item => {
      if(input[item] == "") {
        error[item] = "Required";
      }

      if(input[item]) {
        switch(item) {
          case "email":
            if(!validator.isEmail(input['email'])) {
              error[item] =  "Invalid email";
            }
            break;
          
          default:
            break;
        }
      }
    });
    if(Object.keys(error).length>0) {
      setValidationError(error);
      const ref_focus_key = Object.keys(error)[0];
      ref.current[ref_focus_key].focus();
    }
    return error;
  }

  const submitForm = () => {
    setValidationError({});
    if(Object.keys(checkValidation()).length > 0) {
      return false;
    }
    teamService.eidt(input, team_id).then(rslt => {
      team[team_key] = rslt.data.team_member;
      localStorage.setItem("team", JSON.stringify(team));
      dispatch(teamActions.team(team));
    });
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    submitForm();
    setSubmitted(false);
  }
  return (
    <>
      <section className="pt-4 pb-50 content-min-height">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title">
                <h5>
                  Team
                  <Link to="/user/home" className="ml-2">
                    <FontAwesomeIcon icon={faList} title="List of team" />
                  </Link>
                </h5>
              </div>
              <div className='mt-4'>
                <div className='card border-info' style={{"borderTop": "3px solid"}}>
                  <div className='card-body'>
                    <div className="contact-from pt-0">
                      <div className="main-form">
                        <form onSubmit={handleSubmit} data-submit_status={1}>
                          {/* <div className='row'>
                            <div className="col-md-6 singel-form">
                              <label>First Name<span className='text-danger'>*</span>:</label>
                              <input name="firstname" type="text" value={input.firstname} ref={r => {ref.current['firstname'] = r}} onChange={handleChange} />
                              {validationError.firstname && <span className='text-danger'>{validationError.firstname}</span>}
                            </div>
                            <div className="col-md-6 singel-form">
                              <label>Last Name<span className='text-danger'>*</span>:</label>
                              <input name="lastname" type="text" value={input.lastname} ref={r => {ref.current['lastname'] = r}} onChange={handleChange} />
                              {validationError.lastname && <span className='text-danger'>{validationError.lastname}</span>}
                            </div>
                          </div> */}
                          <div className='singel-form'>
                            <label>Email<span className='text-danger'>*</span>:</label>
                            <input name="email" type="text" value={input.email} ref={r => {ref.current['email'] = r}} onChange={handleChange} />
                            {validationError.email && <span className='text-danger'>{validationError.email}</span>}
                          </div>
                          {/* <div className='singel-form'>
                            <label>Country<span className='text-danger'>*</span>:</label>
                            <input name="nationality_id" type="text" value={input.nationality_id} ref={r => {ref.current['nationality_id'] = r}} onChange={handleChange} />
                            {validationError.nationality_id && <span className='text-danger'>{validationError.nationality_id}</span>}
                          </div> */}
                          <div className='singel-form'>
                            <label>Phone<span className='text-danger'>*</span>:</label>
                            <input name="phone" type="text" value={input.phone} ref={r => {ref.current['phone'] = r}} onChange={handleChange} />
                            {validationError.phone && <span className='text-danger'>{validationError.phone}</span>}
                          </div>
                          <div className='singel-form'>
                            <label>Gender<span className='text-danger'>*</span>:</label>
                            <input name="gender" type="text" value={input.gender} ref={r => {ref.current['gender'] = r}} onChange={handleChange} />
                            {validationError.gender && <span className='text-danger'>{validationError.gender}</span>}
                            {/* <select name='gender'>
                              <option value={""}>Select</option>
                              <option value={"Male"}>Male</option>
                              <option value={"Female"}>Female</option>
                            </select> */}
                          </div>
                          <hr/>
                          <p className="form-message"></p>
                          <div className="singel-form">
                            <button type={submitted? "button": "submit"} className="main-btn btn-info disabled">
                              {submitted ? <span><FontAwesomeIcon icon={faSpinner} className="fa-spin" /> Please wait</span> : <span>Save</span>}
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Edit;